import { Container, Title, Description } from './styles'

export default function QrInfo() {
    return (
        <Container>
            <Title>
                Antes de efetuar o pagamento, leia atentamente as regras:
            </Title>
            <Description>
                Não aceitamos depósitos de terceiros, ou seja, o valor depositado deve vir de uma conta com o seu CPF/CNPJ.
            </Description>
            <Description>
                O valor do depositado não pode ultrapassar o seu limite disponível
            </Description>
        </Container>
    )
}